module.exports = __webpack_public_path__ + "static/media/reporte2010.ef893fb9.png";